module.exports = __webpack_public_path__ + "img/symbol_amor.4e224f4.webp";